import request from '../../../../api/request';
import {
  FiltersData,
  StudentsRiskHistory,
  StudentsRiskHistoryDetails,
  StudentsRiskHistoryDetailsRouteParams,
  StudentsRiskHistoryParams,
} from './types';

export const STUDENT_RISK_HISTORY = {
  GET_FILTERS_OPTIONS: () => `/maintainers-portal/student-risk-history/filters`,
  GET_STUDENTS_RISK_HISTORY: () =>
    `/maintainers-portal/student-risk-history/students-list`,
  GET_STUDENTS_RISK_HISTORY_DETAILS: `/maintainers-portal/student-risk-history/students-details`,
  EXPORT_STUDENTS_RISK_HISTORY: () =>
    `/maintainers-portal/student-risk-history/export`,
  CREATE_STUDENT_RISK_ACTION: (enrollmentSessionId: string | number) =>
    `/maintainers-portal/student-risk-action/create-action/${enrollmentSessionId}`,
  CREATE_STUDENT_RISK_ACTION_RECORD: (actionId: string | number) =>
    `/maintainers-portal/student-risk-action/create-record/${actionId}`,
};

export function getFiltersOptions() {
  return request<FiltersData>(STUDENT_RISK_HISTORY.GET_FILTERS_OPTIONS());
}

export function getStudentsRiskHistory(params: StudentsRiskHistoryParams) {
  return request<StudentsRiskHistory>(
    STUDENT_RISK_HISTORY.GET_STUDENTS_RISK_HISTORY(),
    {
      params,
    },
  );
}

export function getStudentsRiskHistoryDetails(
  params: Partial<StudentsRiskHistoryDetailsRouteParams>,
) {
  return request<StudentsRiskHistoryDetails>(
    STUDENT_RISK_HISTORY.GET_STUDENTS_RISK_HISTORY_DETAILS,
    {
      params,
    },
  );
}

export type ExportStudentsRiskHistoryParams = {
  schoolId: number;
  year: number;
  periodId: number;
};

export function exportStudentsRiskHistory(
  params: ExportStudentsRiskHistoryParams,
) {
  return request<BlobPart>(
    STUDENT_RISK_HISTORY.EXPORT_STUDENTS_RISK_HISTORY(),
    {
      responseType: 'blob',
      params,
    },
  );
}

export function createStudentRiskAction({
  sessionEnrollmentId,
  ...data
}: Record<string, string>) {
  return request<unknown>(
    STUDENT_RISK_HISTORY.CREATE_STUDENT_RISK_ACTION(sessionEnrollmentId),
    {
      method: 'POST',
      data,
    },
  );
}

export function createStudentRiskActionRecord({
  actionId,
  ...data
}: Record<string, string>) {
  return request<unknown>(
    STUDENT_RISK_HISTORY.CREATE_STUDENT_RISK_ACTION_RECORD(actionId),
    {
      method: 'POST',
      data,
    },
  );
}
